import { render, staticRenderFns } from "./Image.vue?vue&type=template&id=c86cc4ec&scoped=true"
import script from "./Image.js?vue&type=script&lang=js&external"
export * from "./Image.js?vue&type=script&lang=js&external"
import style0 from "./Image.scss?vue&type=style&index=0&id=c86cc4ec&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86cc4ec",
  null
  
)

export default component.exports